import React, { PureComponent } from 'react';
import { useTable } from '@utils/table';

function calculateInterest(creditAmount, interest) {
  let calculatedInterest = interest / 100;
  return (creditAmount * calculatedInterest) / 12;
}

function createAmortizationRows(periodicity, term, creditAmount, increasedAmortizationAmount, amortizationAmount, interest) {
  const multiplier = periodicity === 'month' ? 1 : 3;
  const increasedPaymentPeriod = periodicity === 'month' ? 3 : 1;
  const amortizationRows = [];
  let arrear = creditAmount;
  const terms = Math.ceil(term / multiplier);
  for (let i = 1; i <= terms; i += 1) {
    let amortization = i === increasedPaymentPeriod ? increasedAmortizationAmount + amortizationAmount : amortizationAmount;
    if (amortization > arrear) {
      amortization = arrear;
    }
    const nextInterest = calculateInterest(arrear, interest);
    const payment = nextInterest + amortization;
    arrear = arrear - amortization;
    amortizationRows.push({
      period: i,
      payment,
      interest: nextInterest,
      amortization,
      arrear
    });
  }
  return amortizationRows;
}

export default class AmortizationTab extends PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      amortizationRows: createAmortizationRows(nextProps.periodicity, nextProps.term, nextProps.creditAmount, nextProps.increasedAmortizationAmount, nextProps.amortizationAmount, nextProps.interest)
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      amortizationRows: createAmortizationRows(props.periodicity, props.term, props.creditAmount, props.increasedAmortizationAmount, props.amortizationAmount, props.interest)
    }
  }

  componentDidMount() {
    const tableContainer = document.querySelector(".interest-calculation-block__table-container");

    if (tableContainer) {
      const {initTableGradient} = useTable(
        tableContainer,
        tableContainer.querySelector(".table-container__scroll-container"),
        tableContainer.querySelector("table")
      );
      initTableGradient();
    }
  }

  render() {
    const t = this.props.t;
    const formatter = this.props.formatter;
    const percentFormatter = this.props.percentFormatter;
    return (<div>
      <div>
        <p>{t('Interest:')} {percentFormatter(this.props.interest)}</p>
        <p>{t('Credit amount (inc. VAT):')} {formatter(this.props.creditAmount)}</p>
        <p>{t('Repayment period:')} {this.props.periodicity === 'month' ? this.props.term : Math.ceil(this.props.term / 3)} {t(this.props.periodicity === 'month' ? 'Months' : 'Quarters')}</p>
      </div>
      <div className="table-container table-container--row-borders table-container--row-hover-effect interest-calculation-block__table-container">
        <div className="table-container__scroll-container interest-calculation-block__table-scroll-container">
          <table className="interest-calculation-block__table">
            <thead>
              <tr>
                <th>Period</th>
                <th>Betalning</th>
                <th>Ränta</th>
                <th>Amortering</th>
                <th>Restskuld efter amortering</th>
              </tr>
            </thead>
            <tbody>
              {this.state.amortizationRows.map(r => (<tr key={r.period}>
                <td>{r.period}</td>
                <td>{formatter(r.payment)}</td>
                <td>{formatter(r.interest)}</td>
                <td>{formatter(r.amortization)}</td>
                <td>{formatter(r.arrear)}</td>
              </tr>))}
            </tbody>
          </table>
        </div>
      </div>
    </div>);
  }
}
